import React, { useEffect, useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Container, ContainerMain, ContainerSecundaryImages, ContainerSmallImage } from "./styles";
import { defaultProductImage, handleProductImageError } from "../../util/imageFallback";

const GalleryImages = ({ product, productName, images = [], className, children }) => {
    const [mainImage, setMainImage] = useState({});
    const [secundaryImages, setSecundaryImages] = useState([]);
    const [mainLoaded, setMainLoaded] = useState(false);
    const [loadedIndexes, setLoadedIndexes] = useState({});

    useEffect(() => {
        if (images.length > 0) {
            setMainImage(images[0]);
            if (images.length > 1)
                setSecundaryImages(images);
        }
    }, [images]);

    const handleSecundaryImageClick = (image) => {
        setMainImage(image);
        setMainLoaded(false);
    };

    return (
        <Container className={className}>
            {
                mainImage && (
                    <ContainerMain>
                        {!mainLoaded && (
                            <Skeleton variant="rect" animation="wave" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }} />
                        )}
                        <img
                            src={mainImage?.caminho_imagem || (images.length === 0 ? defaultProductImage(product) : undefined)}
                            alt={`${productName}-0`}
                            style={{ opacity: mainLoaded ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }}
                            onLoad={() => setMainLoaded(true)}
                            onError={(e) => { handleProductImageError(product)(e); setMainLoaded(true); }}
                        />
                        {children}
                    </ContainerMain>
                )
            }
            {
                secundaryImages.length > 0 && (
                    <ContainerSecundaryImages>
                        {
                            secundaryImages.map((image, index) => {
                                return (
                                    <ContainerSmallImage key={`image-${index}`} onClick={() => handleSecundaryImageClick(image)}>
                                        {!loadedIndexes[index] && (
                                            <Skeleton variant="rect" animation="wave" width={64} height={64} />
                                        )}
                                        <img
                                            src={image?.caminho_imagem || defaultProductImage(product)}
                                            alt={`${productName}-${index}`}
                                            style={{ display: loadedIndexes[index] ? 'block' : 'none' }}
                                            onLoad={() => setLoadedIndexes(prev => ({ ...prev, [index]: true }))}
                                            onError={(e) => { handleProductImageError(product)(e); setLoadedIndexes(prev => ({ ...prev, [index]: true })); }}
                                        />
                                    </ContainerSmallImage>
                                )
                            })
                        }

                    </ContainerSecundaryImages>
                )
            }

        </Container>
    );
}

export default GalleryImages;
